export default "__VITE_ASSET__hBLucboj$p4GA1VBUKy2jQ__"